import { echartGaugeYear, echartGaugeMonth } from '../common';
import { filterData } from './common';
import { DEFAULT_LANGUAGE } from '../common-language';
import { TEXTS_GAUGE_YEAR } from './texts';
import { initGaugeYear } from '../common-options/gauge-year';

export function echartUsuarisTotalsGaugeYear(vis, datos) {
  const gaugeYearConfig = {
    idChart: 'chartUsuarisTotalsGaugeYear',
    idNoData: 'no_dataUsuarisTotalsGaugeYear',
    chartName: `${TEXTS_GAUGE_YEAR[DEFAULT_LANGUAGE].get(
      'chartUsuarisTotalsGaugeYear',
    )}`,
    fontSize: 12,
    paramOffsetCenterTitle: 15,
    paramOffsetCenterDetail: 30,
    paramOffsetLabel: -100,
    paramCalculatedOffset: 50,
    paramNumberOfElementsByLine: 5,
  };

  initGaugeYear(gaugeYearConfig, datos);
}

export function echartUsuarisPerTitolGaugeYear(vis, datos) {
  const filterTipos = Dashboards.getParameterValue('filterEMT1Param');
  if (filterTipos.length > 0) {
    const datosFiltrados = filterData(datos.resultset, filterTipos);
    filterTipos.sort((a, b) => a.localeCompare(b));
    // eslint-disable-next-line no-inner-declarations
    function cargarGauge() {
      echartGaugeYear(
        'chartUsuarisTitolGaugeYear',
        'no_dataUsuarisTitolGaugeYear',
        datosFiltrados,
        "ÚS D'EMT. USUARIS PER TÍTOL: ANY",
      );
    }
    if (
      document.querySelector('#chartUsuarisTitolGaugeYear')
        .childElementCount === 0
    ) {
      document
        .querySelector('#tabUsuarisPerTitol')
        .addEventListener('click', () => {
          requestAnimationFrame(() => {
            cargarGauge();
          });
        });
    } else {
      cargarGauge();
    }
  }
}

export function echartUsuarisPerLiniaGaugeYear(vis, datos) {
  const filterTipos = Dashboards.getParameterValue('filterEMT2Param');
  const datosFiltrados = filterData(datos.resultset, filterTipos);
  datosFiltrados.sort((a, b) => Number(a[0]) - Number(b[0]));
  function cargarGauge() {
    echartGaugeYear(
      'chartUsuarisLiniaGaugeYear',
      'no_dataUsuarisLiniaGaugeYear',
      datosFiltrados,
      "ÚS D'EMT. USUARIS PER LÍNIA: ANY",
    );
  }
  if (
    document.querySelector('#chartUsuarisLiniaGaugeYear').childElementCount ===
    0
  ) {
    document
      .querySelector('#tabUsuarisPerLinia')
      .addEventListener('click', () => {
        requestAnimationFrame(() => {
          cargarGauge();
        });
      });
  } else {
    cargarGauge();
  }
}

export function echartUsuarisPerTitolGaugeMonth(vis, datos) {
  const filterTipos = Dashboards.getParameterValue('filterEMT1Param');
  const datosFiltrados = filterData(datos.resultset, filterTipos);
  function cargarGauge() {
    echartGaugeMonth(
      'chartUsuarisTitolMesActual',
      'chartUsuarisTitolMesAnterior',
      'no_dataUsuarisTitolMesActual',
      'no_dataUsuarisTitolMesAnterior',
      datosFiltrados,
      "ÚS D'EMT. USUARIS PER TÍTOL: EVOLUCIÓ ",
      "ÚS D'EMT. USUARIS PER TÍTOL: EVOLUCIÓ ",
    );
  }
  if (
    document.querySelector('#chartUsuarisTitolMesActual').childElementCount ===
      0 ||
    document.querySelector('#chartUsuarisTitolMesAnterior')
      .childElementCount === 0
  ) {
    document
      .querySelector('#tabUsuarisPerTitol')
      .addEventListener('click', () => {
        requestAnimationFrame(() => {
          cargarGauge();
        });
      });
  } else {
    cargarGauge();
  }
}

export function echartUsuarisPerLiniaGaugeMonth(vis, datos) {
  const filterTipos = Dashboards.getParameterValue('filterEMT2Param');
  const datosFiltrados = filterData(datos.resultset, filterTipos);
  datosFiltrados.sort((a, b) => Number(a[0]) - Number(b[0]));
  function cargarGauge() {
    echartGaugeMonth(
      'chartUsuarisLiniaMesActual',
      'chartUsuarisLiniaMesAnterior',
      'no_dataUsuarisLiniaMesActual',
      'no_dataUsuarisLiniaMesAnterior',
      datosFiltrados,
      "ÚS D'EMT. USUARIS PER LÍNIA: EVOLUCIÓ ",
      "ÚS D'EMT. USUARIS PER LÍNIA: EVOLUCIÓ ",
    );
  }
  if (
    document.querySelector('#chartUsuarisLiniaMesActual').childElementCount ===
      0 ||
    document.querySelector('#chartUsuarisLiniaMesAnterior')
      .childElementCount === 0
  ) {
    document
      .querySelector('#tabUsuarisPerLinia')
      .addEventListener('click', () => {
        requestAnimationFrame(() => {
          cargarGauge();
        });
      });
  } else {
    cargarGauge();
  }
}
